<template>
  <div>
    <info-box
      v-if="catererDetails"
      :isLoading="progressCatererDetailsLoading"
      class="m-2"
      title="Caterer Details"
    >
      <div class="caterer-details">
        <div class="grid gap-4 grid-cols-2 mb-2">
          <div>Business Name:</div>
          <div>{{ catererDetails.name }}</div>
        </div>

        <div class="grid gap-4 grid-cols-2 mb-2">
          <div>Address:</div>
          <div>{{ catererDetails.address }}</div>
        </div>

        <div class="grid gap-4 grid-cols-2 mb-2">
          <div>City:</div>
          <div>{{ catererDetails.city }}</div>
        </div>

        <div class="grid gap-4 grid-cols-2 mb-2">
          <div>Phone:</div>
          <div>{{ catererDetails.phone }}</div>
        </div>

        <div class="grid gap-4 grid-cols-2 mb-2">
          <div>Contact Persone:</div>
          <div>
            {{ catererDetails.contact_first_name }}
            {{ catererDetails.contact_last_name }}
          </div>
        </div>
      </div>

      <!-- change caterer button -->
      <button
        class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 mt-6"
        @click="showSelectCatererModal = true"
      >
        <span>Change Caterer</span>
      </button>
    </info-box>

    <info-box v-else title="Add New Caterer">
      <button
        class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 mt-6"
        @click="showSelectCatererModal = true"
      >
        <span>Select</span>
      </button>
    </info-box>

    <!-- change caterer modal -->
    <ChangeCatererModal 
      v-if="showSelectCatererModal"
      @close="showSelectCatererModal = false"
    />
    
  </div>
</template>

<script>
import InfoBox from '@/components/common/InfoBox.vue'
import Api from '@/api/api_v1.0'
import OrderSearchCaterers from '@/components/order/OrderSearchCaterers.vue'
import ChangeCatererModal from '@/components/modals/caterers/ChangeCatererModal'


export default {
  components: {
    InfoBox,
    OrderSearchCaterers,
    ChangeCatererModal
  },
  
  data () {
    return {
      progressCatererDetailsLoading: true,
      catererDetails               : false,
      showSelectCatererModal       : false,
    }
  },

  mounted () {
    this.init()
  },
  

  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },

  },

  methods: {
    async init () {
      if (this.order.caterer) {
        await this.loadCatererDetails()
      }
    },

    async loadCatererDetails () {
      this.progressCatererDetailsLoading = true
      const response = await Api.getCatererDetails(this.order.caterer.id)
      this.catererDetails = response.data
      this.progressCatererDetailsLoading = false
    },
  }
}
</script>

<style></style>
